export default __webpack_public_path__ + "static/new-roma-1-fec6ad12fe1e377be46a6e5b40c731f0.jpg";